import { Button, Stack } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { DataHandler } from "../dataHandler";



function Menu() {

    const navigate = useNavigate();

    const checkSessionExpired=()=>{
        DataHandler.checkSessionExpired().catch(()=>{
            navigate('/login');
        })
    }

    const lieferschein = () => {
        navigate("/ls");
        checkSessionExpired();
    }
    const lieferscheinliste = () => {
        navigate("/list");
        checkSessionExpired()
    }

    const rechnung = () => {
        navigate("/rg");
        checkSessionExpired();
    }
    const rechnungsliste = () => {
        navigate("/lsrg");
        checkSessionExpired()
    }

    const kundenliste = ()=>{
        navigate("/lsKunden");
        checkSessionExpired()
    }

    const zeiterfassung = ()=>{
        navigate("/zeit");
        checkSessionExpired()
    }

    const logout = () => {
        DataHandler.doLogout().then(()=>{
            navigate('/login');
        })
        
    }

    const kunden = () => {
        navigate("/kunden");
        checkSessionExpired();
    }

    const stackClass = 'justify-content-center col-md-5 mx-auto '
    return (
        <Stack className={stackClass} gap={3}>
            <Button variant="primary" onClick={lieferschein}>Lieferschein</Button>
            <Button variant="secondary" onClick={lieferscheinliste}>Lieferscheinliste</Button>
            <Button variant="info" onClick={rechnung}>Rechnung</Button>
            <Button variant="dark" onClick={rechnungsliste}>Rechnungsliste</Button>
            <Button variant="primary" onClick={kunden}>Kunde</Button>
            <Button variant="secondary" onClick={kundenliste}>Kundenliste</Button>
            <Button variant="success" onClick={zeiterfassung}>Zeiterfassung</Button>
            <Button variant="danger" onClick={logout}>Logout</Button>
        </Stack>
    )

}

export default Menu;